import React from 'react';
import { TablePagination } from '@odin-labs/components';

type TablePaginationProps = React.ComponentProps<typeof TablePagination>;

export type PaginationProps = {
  pageIndex: number;
  pageCount: number;
  pageSize: number;
  onPageChange: (pageSize: number, newPageIndex: number) => void;
};

export function Pagination(props: PaginationProps): React.ReactElement {
  const { pageIndex, pageSize, pageCount, onPageChange } = props;

  const gotoPage: TablePaginationProps['instance']['gotoPage'] = (
    updater: number | ((pageIndex: number) => number),
  ) => {
    onPageChange(
      pageSize,
      typeof updater === 'number' ? updater : updater(pageIndex),
    );
  };

  return (
    <TablePagination
      instance={
        {
          canPreviousPage: pageIndex > 0,
          canNextPage: pageIndex < pageCount - 1,
          pageCount,
          gotoPage,
          nextPage: () => gotoPage(pageIndex + 1),
          previousPage: () => gotoPage(pageIndex - 1),
          state: { pageIndex },
        } as TablePaginationProps['instance']
      }
    />
  );
}
